// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rgraF","right":"styles_right__2gDV7"};